import { library } from '@fortawesome/fontawesome-svg-core';
import { 
    faBars,
    faSearch,
    faXmark
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faBars,
    faSearch,
    faXmark
);